<ng-container *appTranslate="let t">
  <new-ui-dashboard-card>
    <ng-template #header>
      <new-ui-dashboard-card-header
        [title]="t('dashboard.sharings.title')"
        [routerLink]="settings.isLicensed ? '/app/collections/edit' : null"
      >
        <span class="row items-center gap-2">
          <span class="row"
            >{{ t("dashboard.sharings.total") }}
            @defer (when sharedCollections()) {
              {{ sharedCollections().totalSharings }}
            } @placeholder {
              <p-skeleton shape="circle" size="1.5rem" />
            }
          </span>
          <new-ui-button (onClick)="filter.toggle($event)" icon="pi pi-filter" severity="secondary"></new-ui-button>

          <p-popover #filter>
            <div class="row items-center gap-2">
              <p-toggleswitch [(ngModel)]="hideEmptyLists"></p-toggleswitch>
              <span>{{ t("dashboard.sharings.hideEmptyCollections") }}</span>
            </div>
          </p-popover>
        </span>
      </new-ui-dashboard-card-header>
    </ng-template>

    @defer (when sharedCollections()) {
      <p-tabs class="min-w-fit" value="0">
        <p-tablist class="min-w-fit">
          <p-tab value="0">{{ t("dashboard.sharings.presentation.title") }}</p-tab>
          <p-tab value="1">{{ t("dashboard.sharings.readWrite.title") }}</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="0">
            @if (sharedCollections().presentation?.length > 0) {
              <new-ui-dashboard-list [values]="sharedCollections().presentation" />
            } @else {
              <ui-emptystate
                class="py-[3%]"
                image="/assets/layout/images/new-ui/search.png"
                [caption]="t('dashboard.sharings.presentation.emptyState.title')"
                [description]="t('dashboard.sharings.presentation.emptyState.description')"
              />
            }
          </p-tabpanel>
          <p-tabpanel value="1">
            @if (sharedCollections().readAndWrite?.length > 0) {
              <new-ui-dashboard-list [values]="sharedCollections().readAndWrite" />
            } @else {
              <ui-emptystate
                class="py-[3%]"
                image="/assets/layout/images/new-ui/search.png"
                [caption]="t('dashboard.sharings.readWrite.emptyState.title')"
                [description]="t('dashboard.sharings.readWrite.emptyState.description')"
              />
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    } @placeholder {
      <ul class="col gap-4 p-0 pr-2">
        @for (item of [1, 2, 3]; track item) {
          <li class="flex flex-col mobile:flex-row gap-4 p-2 border border-surface-border rounded-lg shadow-sm">
            <div class="basis-1/2 row gap-2">
              <p-skeleton shape="circle" size="1.25rem" />
              <p-skeleton class="h-5 w-40" />
            </div>
            <div class="basis-1/2 row gap-2">
              <p-skeleton shape="circle" size="1rem" />
              <p-skeleton class="h-5 w-24" />
            </div>
          </li>
        }
      </ul>
    }
  </new-ui-dashboard-card>
</ng-container>
